import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, Dropdown, Popconfirm, Popover, Space, Tag } from 'antd';
import React, { useState } from 'react';
import { queryKeys } from '../../services/react-query/queryKeys';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { ModalAddHolidayList } from '../../components/upeosoft/ModalApp/ModalApp';
import { deleteHolidayList, getHolidayList } from '../../network/holidayList';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
import DashboardCards from '../Dashboard/DashboardCards';
const HolidayList = ({ t }) => {
  const client = useQueryClient();
  const [searchText, setSearchText] = useState('');
  const { message } = App.useApp();
  const [open, setOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const [edit, setEdit] = useState(false);
  const handleRemove = useMutation({
    mutationFn: (id) => deleteHolidayList(id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message ? data?.message : 'Deleted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getHolidayList] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getHolidayList],
    queryFn: () => getHolidayList(),
    keepPreviousData: true,
  });
  const items = (record) => [
    {
      key: '1',
      label: t.edit,
      icon: <MdModeEditOutline />,
      onClick: () => {
        setEditId(record?.name);
        setEdit(true);
        setOpen(true);
      },
    },
    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.DeleteHoliday + ` (${record?.name})`}
          description={t.areYouSure}
          onConfirm={() => handleRemove.mutate(record?.name)}
          // onCancel={cancel}
          okText={t.yes}
          cancelText={t.no}
        >
          <span style={{ color: 'red' }}>{t.Delete}</span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: t.Name,
      dataIndex: 'name',
      key: 'name',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(record?.name).toLowerCase();
        const searchValue = value.toLowerCase();
        return name.includes(searchValue);
      },
    },
    {
      title: t.FromDate,
      dataIndex: 'from_date',
      key: 'from_date',
    },
    {
      title: t.ToDate,
      dataIndex: 'to_date',
      key: 'to_date',
    },
    {
      title: t.TotalHolidays,
      dataIndex: 'total_holidays',
      key: 'total_holidays',
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 200,
      render: (text, record) => {
        return (
          <Space>
            {/* <Button
              size="small"
              type="primary"
              onClick={() => {
                setEditId(record?.name);
                setEdit(true);
                setOpen(true);
              }}
              icon={<MdModeEditOutline />}
            />
            <Popconfirm
              title={t.DeleteHoliday + ` (${record?.name})`}
              description={t.areYouSure}
              onConfirm={() => handleRemove.mutate(record?.name)}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger icon={<MdDelete />} />
            </Popconfirm> */}
            <Dropdown
              menu={{ items: items(record) }}
              overlayClassName="custom-dropdown"
              trigger={['click']}
            >
              <Button
                type="text"
                icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
              />
            </Dropdown>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      key: index,
      ...item,
    };
  });
  return (
    <div className="holiday-list">
      {/* <Heading title={t.HR} subTitle={t.HolidayList} path="/" /> */}
      <DashboardCards t={t} />
      <div className="mt-5">
        <DynamicTableAnt
          columns={columns}
          data={dataTable}
          loading={isLoading}
          setSearchText={setSearchText}
          Placeholder={t.searchByName}
          buttonModal={
            <Button
              type="primary"
              onClick={() => {
                setEditId(null);
                setEdit(false);
                setOpen(true);
              }}
            >
              <PlusOutlined
                style={{
                  fontSize: '10px',
                }}
              />
              {t.AddHoliday}
            </Button>
          }
        />
      </div>
      <ModalAddHolidayList
        t={t}
        open={open}
        setOpen={setOpen}
        editId={editId}
        edit={edit}
        setEdit={setEdit}
      />
    </div>
  );
};

export default HolidayList;
